import isComponentIncluded from '../../BusinessHealthWidget/helpers/isComponentIncluded';
import { QUESTION_DEFINITIONS } from '../../constants';
import { BusinessHealthResponse, HealthScoreOverallStatus, QuestionKey } from '../../types';

const filterInsights = (
    status: HealthScoreOverallStatus | HealthScoreOverallStatus[],
    data?: BusinessHealthResponse,
) => {
    if (!data?.healthscore?.components || !data?.insights) return [];
    const statusArray = Array.isArray(status) ? status : [status];
    return Object.keys(QUESTION_DEFINITIONS).map((questionKey) => {
        const key = questionKey as QuestionKey;
        const definition = QUESTION_DEFINITIONS[key];
        const { scoreId = '', question = '' } = definition || {};
        const score = data.healthscore?.components[scoreId];
        const insight = data.insights?.[key];
        return {
            ...QUESTION_DEFINITIONS[key],
            questionKey: key,
            status: score?.status || '',
            question: insight?.question || question,
            headline: insight?.headline || '',
            summary: insight?.summary || '',
            insights: insight?.insights || '',
            action: insight?.action,
            included: isComponentIncluded(scoreId, data),
        };
    }).filter((questionKey) => {
        const { status: questionStatus, included } = questionKey;
        return included && statusArray.includes(questionStatus);
    });
};

export default filterInsights;
